module.exports = __webpack_public_path__ + "static/2-Sputnik-1957-6730994b1e7b6fb7fea62dd1f2f64605.jpg";